(function() {
    var $body = $('body');
    var $header = $('.main-header');
    var $navRow = $('.navigation', $header);
    var $mobileNavMenu = $('.js-mobile-navigation');
    var $searchForm = $('.search-form', $navRow);
    var $searchInput = $('input[type="search"]', $searchForm);
    var $searchBtn = $('button', $searchForm);
    var $closeLink = $('.js-close-search', $searchForm);
    var $searchOverlay = $('.js-search-overlay');
    var $searchSuggestions = $('.dimSearchSuggContainer');
    var $pageOverlay = $('.js-overlay');
    var sizes = {
        xs: 400,
        sm: 568, // iPhone 5 in landscape mode
        md: 768
    };

    function viewIsUnder(breakpoint) {
        return Boolean(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', function() {
        if ( !viewIsUnder(sizes.md) && $body.hasClass('mobile-nav-open') ) {
            $body.removeClass('mobile-nav-open');
            $pageOverlay.removeClass('show');
            $mobileNavMenu.removeClass('show');
            $pageOverlay.addClass('hide');
        }
    });

    $searchInput.on('focus', function() {
        if ( viewIsUnder(sizes.sm) ) {
            $body.addClass('search-open');
        }
    });

    $searchInput.on('blur', function() {
        $body.removeClass('search-open');
    });

    $searchBtn
        .on('click', function(e) {
            e.preventDefault();
            if ( !$searchInput.val() ) {
                $searchInput.focus();
                $searchBtn.blur();
            } else {
                $searchForm.submit();
            }
        });
    $closeLink.on('click', function(e) {
        e.preventDefault();
        $body.removeClass('search-open');
        $searchInput.val('');
    });

    $searchForm.on('submit', function(e) {
        if ( !$searchBtn.prop('disabled') ) {
            e.preventDefault();
            $searchBtn.prop('disabled', true);
            $searchSuggestions.hide();
            $searchForm.submit();
        }
    });

    $searchOverlay.on('click focus', function() {
        $body.removeClass('search-open');
    });
})();